import { render, staticRenderFns } from "./QuestionMatchAny.vue?vue&type=template&id=4f56e9fe&scoped=true&"
import script from "./QuestionMatchAny.vue?vue&type=script&lang=js&"
export * from "./QuestionMatchAny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56e9fe",
  null
  
)

export default component.exports